import {
    getDisplayValue
} from '../format-display-value';

import {
    timestampMerger
} from './timestamp-merger';

/**
 * Station data should consist of the following format
 * {
 *  HistoricForecast: [
 *      {
 *          DewPoint: null
 *          Gust: null
 *          Humidity: number
 *          IsForecast: boolean
 *          IsWindCalculated: boolean
 *          Rainfall10AM: null
 *          Rainfall9AM: null
 *          StationDateTicks: number
 *          StationDateTime: string
 *          StationId: number
 *          StationName: string
 *          Temperature: number
 *          WeatherObservationId: number
 *          WindDirDeg: number
 *          WindDirection: string
 *          WindSpeed: number
 *          wind_src: null
 *      }
 *  ],
 *  Observations: [
 *      {
 *          DewPoint: number,
 *          Gust: null,
 *          Humidity: number,
 *          IsForecast: boolean,
 *          IsWindCalculated: boolean,
 *          Rainfall10AM: number
 *          Rainfall9AM: number,
 *          StationDateTicks: number,
 *          StationDateTime: string,
 *          StationId: number,
 *          StationName: string,
 *          Temperature: number,
 *          WeatherObservationId: number,
 *          WindDirDeg: null,
 *          WindDirection: null,
 *          WindSpeed: null,
 *          wind_src
 *      }
 *  ],
 *  StationInfo: {
 *      CsDashboardId: null,
 *      DeploymentStatus: null,
 *      Description: string,
 *      Elevation: number,
 *      FTSID: null,
 *      ForecastDistrictId: string,
 *      FunctionalStatus: null,
 *      InList: null,
 *      JurisdictionId: number,
 *      JurisdictionName: string,
 *      Latitiude: string,
 *      LinkUrl: string,
 *      Longitude: number,
 *      StationAnemometerHeight: null,
 *      StationName: string,
 *      StationNumber: string,
 *      StreetAddress: null,
 *      Tz: string,
 *      UnitType: string,
 *      WMOID: number,
 *      WarningValid: null,
 *      WeatherStationId: number
 *  }
 * }
 * @param {*} detailsContainer 
 * @param {*} stationData 
 */
export function drawStationSubPanel(detailsContainer, stationData) {
    const panelContainer = $(`<div></div>`);
    panelContainer.css({
        'display': 'flex',
        'align-items': 'center',
        'justify-content': 'space-between',
        'width': '100%',
        'padding': '4px'
    })

    const obs = stationData['Observations'].at(-1);

    const containerCss = {
        'border-width': '1px',
        'border-style': 'solid',
        'border-radius': '4px',
        'border-color': 'black',
        'padding': '4px'
    }

    // Wind gusts
    const windGusts = $(`<div>Wind gusts : ${obs['Gust']} km/h</div>`);
    windGusts.css(containerCss);

    // Rainfall 9AM
    const rain9AM = $(`<div>Rainfall 9AM : ${obs['Rainfall9AM']} mm</div>`);
    rain9AM.css(containerCss);

    // Rainfall 10AM
    const rain10AM = $(`<div>Rainfall 10AM : ${obs['Rainfall10AM'] ? obs['Rainfall10AM'] + ' mm' : '-'}</div>`);
    rain10AM.css(containerCss);

    // Open external page

    // Combine everything together
    panelContainer.append(windGusts);
    panelContainer.append(rain9AM);
    panelContainer.append(rain10AM);
    
    detailsContainer.append(panelContainer);
}